import { withRBAC } from "../rbac";
import type { Contact } from "../types";
import { ContactCreate } from "./ContactCreate";
import { ContactEdit } from "./ContactEdit";
import { ContactList } from "./ContactList";
import { ContactShow } from "./ContactShow";

export default {
  list: withRBAC(ContactList, "view_sales_pipeline"),
  show: withRBAC(ContactShow, "view_sales_pipeline"),
  edit: withRBAC(ContactEdit, "view_sales_pipeline"),
  create: withRBAC(ContactCreate, "view_sales_pipeline"),
  recordRepresentation: (record: Contact) =>
    record?.first_name + " " + record?.last_name,
};
